'use strict';

import ajax from '../../../ajax';
import image from './image';
import productSet from '../productSet';
import progress from '../../../progress';
import productStoreInventory from '../../../storeinventory/product';
import socialShareIcons from '../socialShareIcons';
import util from '../../../util';
import recommendations from '../recommendations';
import imagesLoaded from 'imagesloaded';
import customModal from '../../../modal';
import customDropdown from '../../../custom-dropdown';
import productDetail from '../../../pages/product-detail';
import copyTextClipboard from '../../../copy-text-clipboard';
import miniCrossSell from '../../../mini-crosssell';
import reassurance from '../../../pages/product/reassurance';
import {dialogSDK} from '../../../pages/product/dialogSDK';


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/

function productSetColorSwatchesCarousel() {
	var colorSwatchSlider = $('#product-set .swatches.color:not(.sticky-swatches)');
	if($(window).width() <= 768 && colorSwatchSlider.length) {

		colorSwatchSlider.not('.slick-initialized').slick({
			arrows: true,
			dots: false,
			infinite: true,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: false,
			slidesToShow: 2,
			slidesToScroll: 2
		});
		// automatically slide to selected variant
		colorSwatchSlider.each(function() {
			var selectedVariant = $(this).find('li.selected');
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index');
			$(this).slick('slickGoTo', indexOfSelected, false);
		});
	} else {
		if (colorSwatchSlider.hasClass('slick-initialized')) {
			colorSwatchSlider.slick('destroy');
		}
	}
}

// Sticky Scroll Image container
if ($('.pdp-redesign .product-image-container').length) {
	var stickySidebar = new StickySidebar('.pdp-redesign .product-image-container', {
		topSpacing:  0,
		bottomSpacing: 0,
		resizeSensor: true,
		innerWrapperSelector: '.sidebar__inner'
	});
}
function resizeStickySidebar() {
	if ($(window).width() < 991 && $('.pdp-redesign .product-image-container').length && stickySidebar) {
		stickySidebar.destroy();
	}
}

function updateContent(href,pid, callback) {
	var $pdpForm = $('.pdpForm'),
		qty = $pdpForm.find('select[name="Quantity"] option:selected').val(),
		activeThumbnail = $('#thumbnails .slick-slide').first().attr('data-slick-index');
	
	var repleCycle = $('select#replencycle option:selected').length > 0 ? $('select#replencycle option:selected').val() : '0';

	var params = {
		repleCycle : repleCycle,
		Quantity: isNaN(qty) ? '1' : qty,
		format: 'ajax',
		productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
	};
	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#product-content'),
		callback: function () {
			if (SitePreferences.STORE_PICKUP) {
				productStoreInventory.init();
			}
			initColorCategoryFilter();
			render3DVisualisation();
			var stickyElememt = $('#product-content').find('.sticky-buy-section');
			var stickyContent = stickyElememt.html();
			var ajaxFlag = true;
			stickyElememt.html('');
			updatePdpStickyContent(stickyContent);
			updateContentSticky(stickyContent);
			
			socialShareIcons();
			recommendations.init();
			
			if ($('#pdp-top-quantity').length) {
				$('select').selectmenu({
					width: false,
					position: {
						my: "left top",
						at: "left bottom",
						collision: "flip flip"
					}
				});
				$("#pdp-top-quantity-menu").parent().addClass("pdp-qty-width");
				syncQtyDropdownValue($('.quantity-dropdown'));
			}
			
			const $liveRegion = $('.price-live-region');
			if ($liveRegion.length) {
				const html = $liveRegion.html();
				$liveRegion.empty();
				setTimeout(function () {
					$liveRegion.html(html);
				}, 500);
			}
			
			initColorShadesSlider();
			initMiniCrossSellPDP();
			initReassuranceCarousel();
			customDropdown.init();
			updateReplanishCycle();
			
			imagesLoaded('.product-thumbnails .productthumbnail').on('done', function () {
				$('.fade-circle').removeClass('hidden');
				$(document).trigger("gtvariationchange");
			});
			scrollToActiveSizeVariant();
			
			// scroll to selected category
			var selectedVariant = $('#product-content .pdp-color-category-filter li.selected'); // get the selected variant
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index'); // know it's index
			var updatedIndex  = indexOfSelected > 1 ? indexOfSelected - 1 : indexOfSelected;
			indexOfSelected > 1 && $('#product-content .pdp-color-category-filter').slick('slickGoTo', updatedIndex, false);

			checkVariantScrollReachedEnd();
			applyTransparentGradientOnScroll();
			initStickyAddToBag();
			$('html').removeClass('modal-open');
			hideOverflowingList();
			// Enable the add-to-cart button
			if ($('.disabled-onload') && $('.disabled-onload').length > 0){
				$('.disabled-onload').removeClass('disabled-onload');
			}
			setTimeout(() => {
				// initialize ui-accordion
				productDetail.init();
				// reinit stickySidebar after variation change
				if ($(window).width() >= 991 && $('.pdp-redesign .product-image-container').length) {
					stickySidebar = new StickySidebar('.pdp-redesign .product-image-container', {
						topSpacing: 0,
						bottomSpacing: 0,
						resizeSensor: true,
						innerWrapperSelector: '.sidebar__inner'
					});
				}
				image(); // removed image() params to enable zoom feature
			}, 2000);
			copyTextClipboard.init();
			if (SitePreferences.DIALOG_SCRIPT_ENABLED) {
				dialogSDK.initPDP();
			}
			if (callback) {
				callback();
			}
		},
	})
}

function updateContentSticky(stickContent) {
	var $pdpForm = $('.pdpForm');
	var qty = $('#product-content-sticky').find('select[name="Quantity"] option:selected').val();

	$('#product-content-sticky').html(stickContent);

	if (SitePreferences.STORE_PICKUP) {
		productStoreInventory.init();
	}
	$('select').selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
	$("#pdp-top-quantity-menu").parent().addClass("pdp-qty-width");
	syncQtyDropdownValue($('.quantity-dropdown'));
	socialShareIcons();
	
}

//product set total
function getProductSetTotal() {	return new Promise(function (resolve, reject) {
	var totalSalePrice = 0, 
	totalStdPrice = 0, 
	tempNumSale = 0, 
	tempNumStd = 0;

	$('.product-set-list  .product-price-value').each(function(){
		//Sale Price
		tempNumSale = $(this).find(".price-sales").text();
		tempNumSale = tempNumSale.replace(/[^0-9]+/g,"");
		tempNumSale = parseFloat(tempNumSale/100);
		totalSalePrice += tempNumSale;
		//Std Price
		tempNumStd = $(this).find(".price-standard").text() ? $(this).find(".price-standard").text() : $(this).find(".price-sales").text();
		tempNumStd = tempNumStd.replace(/[^0-9]+/g,"");
		tempNumStd = parseFloat(tempNumStd/100);
		totalStdPrice += tempNumStd;
	});
	
	totalSalePrice = totalSalePrice.toFixed(2);
	totalStdPrice = totalStdPrice.toFixed(2);	
	
	var currencyLocale = window.User.locale.replace(/_/g, '-');
	var formattedSalePrice = util.getFormattedCurrency(currencyLocale,  window.User.currencyCode, totalSalePrice);	
	var formattedStdPrice = util.getFormattedCurrency(currencyLocale,  window.User.currencyCode, totalStdPrice);
	
	return resolve(totalSalePrice==totalStdPrice ? {'salesPrice' : formattedSalePrice} : {'salesPrice':formattedSalePrice, 'standeredPrice':formattedStdPrice});

	});
}

//product set button enable/disable
function setAddToCartPS() {
	var avail = "",
	flag = 0;
	$('.product-set-list  .product-set-item').each(function(){
		//avail
		avail = $(this).find("input[name=availability]").val();
		flag = avail == "NOT_AVAILABLE" ? 1 : flag;
	});
	
	if(flag == 1) {
		$('#add-all-to-cart').attr('disabled', 'disabled');
		$('.bundle-sticky-buy-container .add-to-cart-in-stock').addClass('disabled');
		$('.bundle-sticky-buy-container .add-to-cart').attr('disabled', 'disabled');
		$('#findstore-wrapper').removeClass('visually-hidden');
	} else {
		$('#add-all-to-cart').removeAttr('disabled');
		$('.bundle-sticky-buy-container .add-to-cart-in-stock').removeClass('disabled');
		$('.bundle-sticky-buy-container .add-to-cart').removeAttr('disabled');
		$('#findstore-wrapper').addClass('visually-hidden');
	}
}

function updateSetContent($ele, href) {
	var $productSetItemCtnr = $ele.parents(".product-set-item"),
		qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

	progress.show($productSetItemCtnr);

	$.get(util.appendParamsToUrl(href, {
		Quantity: isNaN(qty) ? '1' : qty,
		format: "ajax",
		setproduct: true
	})).done(function (html) {
		$productSetItemCtnr.html(html);
		// re-initialize all the selectmenu 
		$('select').selectmenu({
			width: false,
			position: {
				my: "left top",
				at: "left bottom",
				collision: "flip flip"
			}
		});
		
		getProductSetTotal().then(function(productPriceDisp){
			if(window.isProductSetCustomPrice === false){
				$('#product-set .price-details .salesprice').html(productPriceDisp.salesPrice);
				$('.bundle-sticky-buy-container .product-price .salesprice').html(productPriceDisp.salesPrice);
			}
			if(productPriceDisp.standeredPrice) {
				$('.price-standard-set').text(productPriceDisp.standeredPrice);
			} else {
				$('#product-set .price-details .salesprice-std').html("");
				$('.bundle-sticky-buy-container .product-price .salesprice-std').html("");
			}			
			setAddToCartPS();
			productSetColorSwatchesCarousel();
		});

	});
}

function updatePdpStickyContent(stickyContent) {
	$(".stick-buy-container .product-details").html(stickyContent)
	$('select').selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
}

/**
 * @description update sticky buy swatch dropdown
 **/
function updateStickyBuySwatchDropdown() {
	var $swatchsDropdown = $('.stick-buy-container .swatches-dropdown'),
		$selectedSwatch = $('.stick-buy-container #pdp-swatches li.selected .swatchanchor');
	$swatchsDropdown.html($selectedSwatch.html());
	$swatchsDropdown.off().on('click', function () {
		$(this).toggleClass('active');
		$(this).siblings('#pdp-swatches').toggleClass('active').css('width', $swatchsDropdown.innerWidth());
	});
}

function syncQtyDropdownValue($dropdownElem) {
	$dropdownElem.on('selectmenuchange change', function () {
		$dropdownElem.val($(this).val());
		$dropdownElem.selectmenu().selectmenu('refresh');
	});
}

function updateQuantityOnChange() {
	var $quantityDropdown = $('.quantity-dropdown')
	$quantityDropdown.selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
	syncQtyDropdownValue($quantityDropdown);
}

function updateReplanishCycle() {
	//On Change Select in PDP
	$('.replenishmentCycle').on('selectmenuchange change', function () {
		var footerURL = window.location.href;
		var selection = $(this).val();

		if (window.User.isCustomerAuthenticated == false && selection != 0) {
			$('.replenishmentCycle').val('0');
			$('.replenishmentCycle').selectmenu('refresh');

			$.ajax({
				url: Urls.replenishmentLogin,
				success: function (response) {
					if($('.replenishment-onchange').length > 0) {
						if ($('.quickview-modal').length > 0) {
							customModal.createCustomModal('replenishment-onchange-modal quickview-replenishment', '#modal-custom-placeholder');
						} else {
							customModal.createCustomModal('replenishment-onchange-modal', '#modal-custom-placeholder');
						}
						$('.replenishment-onchange-modal .modal-body').html(response).scrollBox();
					}

					$('.modal-btn-signin').click(function () {
						var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
						window.location = urlLink;
					});

					$('.modal-btn-register').click(function () {
						var urlLink = util.appendParamToURL(Urls.showCreateAccount, 'original', footerURL);
						window.location = urlLink;
					});
				}
			});
		} else {
			var $dropdownElem = $('.replenishmentCycle');
			$dropdownElem.val(selection);
			$("input[name='replenishmentCycle']").val(selection);
			$dropdownElem.selectmenu().selectmenu('refresh');
		}
	});
}

function initColorCatFiltersEvents() {
	$(document).on('click keydown', '.color-filter-attr', function (e) {

		if (e.type === 'keydown' && e.key !== 'Enter') return;

		const $container = $(this).closest('.pdp-vars'); // scope-safe
		const selectedValue = $(this).text().trim();
		const selectedColor = $(this).data('color');

		handleColorSwatches($container, selectedValue, selectedColor);
	});


	$(document).on('click keydown', '.product-shade-panel .color-filter-attr', function (e) {
		// Trigger only on click OR Enter key
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
		e.stopPropagation();
		const selectedValue = $(this).text();
		const $shadePanelList = $('.product-shade-panel .custom-dd-list-item');
		const countOfShadesWithSelectedColorCat = $shadePanelList.filter(function () {
			const curVal = $(this).data('ccatvalues') || '';
			const curValArr = curVal.split(", ");
			return curVal && curValArr.includes(selectedValue);
		}).length;
		const selectedColor = $(this).data('color');
		$('.product-shade-panel').find('.shade-count').text(countOfShadesWithSelectedColorCat);
		const $panelColorFilters = $('.product-shade-panel .color-filter-attr');
		$panelColorFilters.removeClass('selected').attr('aria-pressed', 'false').each(function () {
			const $this = $(this);
			$this.attr('aria-label', $this.text().trim() + ', ' + $this.data('not-selected-label'));
		});
		$panelColorFilters.filter('[data-color="' + selectedColor + '"]').addClass('selected').attr('aria-pressed', 'true').each(function () {
			const $this = $(this);
			$this.attr('aria-label', $this.text().trim() + ', ' + $this.data('selected-label'));
		});
		 $shadePanelList.filter(function () {
			const $this = $(this);
			const curVal = $this.data('ccatvalues') || '';
			const curValArr = curVal.split(", ");
			if (curVal && curValArr.includes(selectedValue)) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});

		if (e.type === 'keydown'){
			// Add class to last visible one
			$shadePanelList.removeClass('productshadelastelement');
			$shadePanelList.filter(':visible').last().addClass('productshadelastelement');
		}

		productInteractionAnalytic(selectedValue);
	});

	function productInteractionAnalytic(selectedValue){
		const selectedColorCat = localStorage.getItem('selColorCat');
		if (selectedColorCat && selectedColorCat != selectedValue) {
                // track event
                if ($('.quickview-modal').length === 0 && window.dataLayer) {
					if (pageInfo.pageCategory == "Product Page") {	
						window.dataLayer.push(util.filterObj({
							"event": "productInteraction",
							"productName": getProductNameWithoutSpace(),
							"productId": $('#pid').val(),
							"interactionType" : "select_category_shade"
						}));
					}
                }
        }
	}
}

function handleColorSwatches($container, selectedValue, selectedColor) {
	const $filters = $container.find('.color-filter-attr');
	const $swatchesWrapper = $container.find('#pdp-swatches.swatches.color');
	const $swatches = $swatchesWrapper.find('li').not('.remaining-count');
	const defaultValue = $filters.filter('.default').first().text().trim();

	if (!$swatchesWrapper.length) return;
	/* ---------------------------
	   1. Update Selected Filter UI
	--------------------------- */
	$filters.removeClass('selected').attr('aria-pressed', 'false').each(function () {
		$(this).attr('aria-label', $(this).text().trim() + ', ' + $(this).data('not-selected-label'));
	});
	$filters.filter(`[data-color="${selectedColor}"]`).addClass('selected').attr('aria-pressed', 'true').each(function () {
		$(this).attr('aria-label', $(this).text().trim() + ', ' + $(this).data('selected-label'));
	});

	localStorage.setItem('selColorCat', selectedValue);
	if ($(document.activeElement).hasClass('color-filter-attr')) {
		if (pageInfo.pageCategory == "Product Page") {
			window.dataLayer.push(util.filterObj({
				"event": "productInteraction",
				"productName": getProductNameWithoutSpace(),
				"productId": $('#pid').val(),
				"interactionType" : "select_category_shade"
			}));
		}
	}
	/* ---------------------------
	   2. Filter Swatches (business logic)
	--------------------------- */
	$swatches.each(function () {
		const $li = $(this);
		const curVal = $li.data('ccatvalues') || '';
		const curValArr = curVal.split(', ');

		if (!selectedValue || selectedValue === defaultValue || curValArr.includes(selectedValue)) {
			$li.show().removeClass('inActive');
		} else {
			$li.hide().addClass('inActive');
		}
	});

	/* ---------------------------
	   3. Auto-select first visible swatch
	--------------------------- */
	const $visibleSwatches = $swatches.filter(':visible');

	if ($visibleSwatches.length && !$visibleSwatches.hasClass('selected')) {
		let $first;

		if ($visibleSwatches.hasClass('selectable')) {
			$first = $swatchesWrapper.find('li.selectable:visible').first();
		} else {
			$first = $visibleSwatches.first();
		}
		window.checkCategoryClicked = true;
		$first.find('.swatchanchor').trigger('click');
	}

	/* ---------------------------
	   4. Overflow Handling
	--------------------------- */

	// Reset hidden state first
	$swatches.removeClass('hidden');

	const wrapperRight = $swatchesWrapper[0].getBoundingClientRect().right;

	// Consider only visible (filtered) swatches
	const $activeSwatches = $swatches.filter(':visible');

	let firstOverflowIndex = -1;

	$activeSwatches.each(function (index) {
		const liRight = this.getBoundingClientRect().right;

		if (liRight > wrapperRight) {
			firstOverflowIndex = index;
			return false;
		}
	});

	if (firstOverflowIndex > 0) {
		$activeSwatches.each(function (index) {
			const $li = $(this);

			if ($li.hasClass('selected')) {
				$li.removeClass('hidden');
				return;
			}

			if (index >= firstOverflowIndex - 1) {
				$li.addClass('hidden').hide();
			}
		});
	}

	/* ---------------------------
	   5. Remaining Count (+X)
	--------------------------- */
	const hiddenCount = $activeSwatches
		.filter('.hidden')
		.not('.selected')
		.length;

	const $remaining = $swatchesWrapper.find('li.remaining-count');

	if ($remaining.length) {
		if (hiddenCount > 0) {
			$remaining.removeClass('hidden').text(`+${hiddenCount}`);
		} else {
			$remaining.addClass('hidden');
		}
	}
}

function initColorCategoryFilter() {
	var selectedColorCat = localStorage.getItem('selColorCat');
	if (selectedColorCat) {
		var prevSelectedFilter = $(".color-filter-wrapper li.color-filter-attr:contains('" + selectedColorCat + "')");

		if (prevSelectedFilter.length && prevSelectedFilter.length > 1) {
			prevSelectedFilter.each((id, elem) => {
				let innerDomText = elem.innerText;
				if (innerDomText.toUpperCase() === selectedColorCat.toUpperCase()) {

					elem.click();
					return;
				}
			});
		} else if (prevSelectedFilter.length) {
			prevSelectedFilter.click();
		}
	}
}

function hideOverflowingList() {
	$('#product-content .pdp-vars').each(function () {
		const $container = $(this);

		let selectedValue = localStorage.getItem('selColorCat');
		let $filter;

		if (selectedValue) {
			// Try matching saved value
			$filter = $container.find('.color-filter-attr').filter(function () {
				return $(this).text().trim() === selectedValue;
			});
		}

		// Fallback to default ("All")
		if (!$filter || !$filter.length) {
			$filter = $container.find('.color-filter-attr.default');
			selectedValue = $filter.text().trim();
		}

		const selectedColor = $filter.data('color');

		// ✅ Run the same unified function
		handleColorSwatches($container, selectedValue, selectedColor);
	});
}

function isOverflowColorShade($wrapper) {
    const $tiles = $wrapper.find('li.color-filter-attr');
    let totalWidth = 0;

    if ($wrapper.length && $tiles.length) {
        $tiles.each(function () {
            totalWidth += $(this).outerWidth(true); // include margin
        });
        return $wrapper.width() <= totalWidth;
    }
    return false;
}

function initColorShadesSlider() {
    $('.pdp-color-category-filter').each(function () {

        const $colorCategory = $(this);

        // Skip if already initialized
        if ($colorCategory.hasClass('slick-initialized')) return;

        if (isOverflowColorShade($colorCategory)) {
			$colorCategory.on('init', function (event, slick) {
                if (!slick || !slick.$slides) return; // check if slick exists
                $colorCategory.find('.slick-active').attr('tabindex', '0');
                $colorCategory.find('.slick-arrow').attr('tabindex', '0');
            });

            $colorCategory.slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 2,
                centerMode: false,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    }
                ]
            }).on('afterChange', function() {
				$colorCategory.find('.slick-slide').attr('tabindex', '0'); // remove all
				$colorCategory.find('.slick-active').attr('tabindex', '0'); // only active slides
        	});
        }
    });
}

// initialize cross sell on click of swatches
function initMiniCrossSellPDP() {
	if($(".mini-cross-sell-wrapper").length) {
		miniCrossSell.init();
	}
}

function initReassuranceCarousel() {
	const $slideLength = $(".reassurance-content-wrapper .reassurance-item").length;
	if($slideLength > 1) {
		reassurance.init();
	}
}

/**
 * @description
 * Apply transparent gradient at the right side of the color and the size variant(PDP & Quickview).
 * Trigger on document ready, window resize and window orientationchange.
 **/
 function applyTransparentGradient() {
	var $scrollableElement = $(document).find('.product-info .swatches.size.mobile-scrollable');
	if($scrollableElement.length && $(window).width() < 768) {
		($scrollableElement.get(0).scrollWidth > $scrollableElement.outerWidth()) ? $(".transparent-gradient").show() : $(".transparent-gradient").hide();		
	}
}

/**
 * @description
 * Apply transparent gradient at the right side of the color and the size variant on scroll of pdp-swatches(PDP & Quickview).
 **/
function applyTransparentGradientOnScroll() {
	$('.product-info .swatches.size.mobile-scrollable').on('scroll', function() {
		checkVariantScrollReachedEnd();	
	});
}

// to check variant reach to the end 
function checkVariantScrollReachedEnd() {
	var $elem = $('.swatches.size.mobile-scrollable');
	var offset = 0;
	var scrollLeft,
		ElemWidth,
		scrollWidth;
	if($elem.length) {
		scrollLeft = $elem.scrollLeft(),
		ElemWidth = $elem.width(),
		scrollWidth = $elem.get(0).scrollWidth;
		// check scroll reached to the right end
		if (scrollWidth - scrollLeft - ElemWidth === offset) {
			$(".transparent-gradient").hide();
		} else {
			$(".transparent-gradient").show();
		}
	}	
}

// scroll to activated swatch, to get better visiblity in the viewport
function scrollToActiveSizeVariant() {
	var $scrollableArea = $('.swatches.size.mobile-scrollable'),
		$activeEle;
		if($scrollableArea.length) {
			$activeEle = $scrollableArea.find('li.selected').find('.swatchanchor');
			if($scrollableArea.outerWidth() <= $activeEle.offset().left) {
				$scrollableArea.animate({scrollLeft: $scrollableArea.scrollLeft() + $activeEle.offset().left}, 500);
				checkVariantScrollReachedEnd();
			}
		}
}

/**
 * @private
 * @function
 * @description screen resize handler.
 */
 function initResizeHandler() {
	// store the window width
	var windowWidth = $(window).width();
	$(window).on('resize orientationchange', function () {
		// check window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() != windowWidth) {
			productSetColorSwatchesCarousel();
			initColorShadesSlider();
			initMiniCrossSellPDP();
			initReassuranceCarousel();
		}
		applyTransparentGradient();
	});
}

// re-initialize Einstein Recommendation carousel
function initEinsteinRecommendations() {
	$(window).on("load", function() {
		setTimeout(function() {
			recommendations.init();
			// to reinit recommended product's quantity dropdown 
			$('.carousel-recommendations select').selectmenu();
		}, 5000);	
	});
}

function initRedesignPDPShadeSizeSelector(){
		if($('#pdp-swatches').hasClass('color')) {
			$('.product-variations').addClass('color-variations');
		}
	
		$('.product-details-wrapper-redesign #pdp-swatches .swatchanchor').contents().filter(function() {
			return this.nodeType === 3; // Filter text nodes
		}).each(function() {
			var text = $(this).text();
			var newText = text.replace(/\((.*?)\)/g, '<div class="round-text">($1)</div>'); // Wrap text within round brackets with <span> element
			$(this).replaceWith(newText); // Replace original text with modified text
		});
		productDetail.init();
}

var InfoWrapperHeight = $('.product-details-wrapper .product-info').outerHeight();
var lastScrollTop = 0;
function initStickyAddToBag() {
	var windowTop = $(window).scrollTop();
	var container;
	let threashHold = 50;
	if($('#header-top-notification-message').length == 0) {
		threashHold = 30;
	}
	if($('#sticky-anchor').length) {
		container = $('#sticky-anchor').offset().top - 60;
	}
	var addToCart = $('.cta-wrapper .add-to-cart-in-stock, .cta-wrapper .coming-soon-container');
	var InfoWrapper = $('.product-details-wrapper .product-info');
	var stickyPlaceholder = $('.sticky-placeholder');

	if (windowTop > container && $('.add-to-cart-out-of-stock.no-variant-product').length === 0) {
		if(!$(addToCart).hasClass('sticky-add-to-bag')) {
			$('.custom-dd.opened').removeClass('opened');
		}
		$(addToCart).addClass('sticky-add-to-bag');
		$(InfoWrapper).addClass('sticky-add-to-bag');
		$(stickyPlaceholder).css('height', InfoWrapperHeight);
	} else {
		$('.sticky-add-to-bag .custom-dd.opened').removeClass('opened');
		$(stickyPlaceholder).css('height', '');
		$(addToCart).removeClass('sticky-add-to-bag');
		$(InfoWrapper).removeClass('sticky-add-to-bag');
		if($(window).width() < 768 && windowTop < lastScrollTop && windowTop > threashHold && !$('#wrapper').hasClass('sticky-header') && !$('html').hasClass('filter-open')) {
			$('#wrapper').addClass('sticky-header');
		}
	}
	lastScrollTop = windowTop - 10;
}

function render3DVisualisation() {
	let hideTimeout;

	$('.threeD-view').on('click', function () {
		customModal.createCustomModal('threeD-view-modal');
		$('.threeD-view-modal').find('.modal-body').html(`
			<div class="ajax-loader" style="display: block;">
				<img class="loader-img" src="`+$('#omiLoaderImg').val()+`" alt="loading...">
			</div>
			<div class="arrow-360-container">
				<img class="arrow-360-img" src="`+$('#Arrow360Img').val()+`" alt="Arrow360Img">
				<div class="text-360">360</div>
			</div>
			<iframe
			id="viewer-3d"
			src="`+$('#omiConfigUrl').val()+`"
			width="100%"
			height="100%"
			allow="accelerometer; autoplay; camera; fullscreen; gyroscope; magnetometer"
			loading="eager"
			style="border: none; overflow: hidden;"
			></iframe>`
		);
		
		 // loader hides when iframe loads + some initialization time
        $('#viewer-3d').on('load', function () {
            setTimeout(() => {
                $('.threeD-view-modal .ajax-loader').fadeOut();
            }, 1200);
        });
	});
}

export default function () {
	// With experience-main-productdetail class, all events and logic are in the same place and will work for the PDP detail wrapper. It will not conflict with Quick Shop modal data.
	var $pdpMain = $('#pdpMain .experience-main-productdetail');
	var $pdpSticky = $('.stick-buy-container');
	let shadePanelTrigger = null;
	let shadePanelTriggerSelector = null;
	let isShadePanelFocusTrapActive = false;

	function restoreShadePanelFocus() {
		let $trigger = $(shadePanelTrigger);

		if (!$trigger.length || !document.body.contains($trigger[0])) {
			$trigger = $(shadePanelTriggerSelector).first();
		}

		if ($trigger.length) {
			$trigger.focus();
		}
		shadePanelTrigger = null;
		shadePanelTriggerSelector = null;
	}

	function closeShadePanel(shouldRestoreFocus) {
		const $shadePanel = $('.product-shade-panel');

		$('#product-shade-panel-status').text($shadePanel.data('closed-message'));
		$('.sticky-component').removeClass('hidden');
		$shadePanel.removeClass('opened');
		$('html').removeClass('modal-open');
		$shadePanel.find('.custom-dd-list-item').removeClass('productshadelastelement');

		if (isShadePanelFocusTrapActive) {
			accessibility.setKeepFocusInside(document.querySelector('#product-shade-panel'), false);
			isShadePanelFocusTrapActive = false;
		}
		$shadePanel.attr('aria-hidden', 'true').attr('inert', '');

		if (shouldRestoreFocus !== false) {
			restoreShadePanelFocus();
		}
	}

	$(window).on('scroll', initStickyAddToBag);
	localStorage.removeItem('selColorCat');
	initStickyAddToBag();
	miniCrossSell.init();
	$pdpMain.on('click keydown', '#product-content li', function (e) {

		// Allow click OR Enter key
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}
		
		e.preventDefault();
		const $swatch = $(this).find('.swatchanchor');

		// Guard clause if no swatch found
		if (!$swatch.length || $swatch.parent().hasClass('selected')) return;

		let urlLink = '';
		let pid = $swatch.attr('data-pid');

		const isPDP = $swatch.closest(".content-pdp").length > 0;
		const inQuickView = $("#product-content").parents("#quickview-modal").length > 0;

		if($(this).hasClass("selectable") || $(this).hasClass("unselectable")) {
			if (pageInfo.pageCategory == "Product Page" && !window.checkCategoryClicked) {
				window.dataLayer.push(util.filterObj({
					"event": "productInteraction",
					"productName": getProductNameWithoutSpace(),
					"productId": pid,
					"interactionType" : "select_shade_selector"
				}));
			} else {
				window.checkCategoryClicked = false;
			}
		}
		if (isPDP) {
			urlLink = Urls.productVariationDetails +
				"?pid=" + $swatch.attr("data-mpid") +
				"&" + $swatch.attr("data-varianttype") + "=" + $swatch.attr("data-variantval") +
				"&Quantity=1&format=ajax";

			if (inQuickView) {
				urlLink += "&" + $swatch.attr("data-cartSrcParam");
			}
		}
		else if ($("#product-content").parent().attr("id") !== "product-set") {
			urlLink = this.href;
		}

		if (urlLink) {
			updateContent(urlLink, pid);
		}

		setTimeout(initRedesignPDPShadeSizeSelector, 1500);

	}).on('change', '#product-content .variation-select', function () {
		if($("#product-content").parent().attr("id") != "product-set"){
			var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
			var link = listItem.find('a.swatchanchor')[0];
			var href = $(link).attr('href');
	
			var $selectedVariantOption = $(this).find("option:selected");
			if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
				return;
			}
			localStorage.removeItem('selColorCat');
			updateContent(href);
			setTimeout(() => {
				initRedesignPDPShadeSizeSelector();
			}, 1500);
			
		}
	});

	$pdpMain.on("selectmenuchange", "#product-content .variation-select", function (event, ui) {
		if($("#product-content").parent().attr("id") != "product-set"){
			var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
			var link = listItem.find('a.swatchanchor')[0];
			var href = $(link).attr('href');
			var $selectedVariantOption = $(this).find("option:selected");
			if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
				return;
			}
			updateContent(href);
		}
	});

	$pdpSticky.on('click', '#pdp-content-sticky .swatchanchor', function (e) {
		e.preventDefault();
		updateContent(this.href);
	});

	$pdpSticky.on("selectmenuchange change", "#pdp-content-sticky .variation-select", function (event, ui) {
		var listItem =  $('#pdp-content-sticky #pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
		var link = listItem.find('a.swatchanchor')[0];
		var href = $(link).attr('href');

		var $selectedVariantOption = $(this).find("option:selected");
		if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
			return;
		}
		updateContent(href);
	});

	$pdpMain.on('click', '.swatchanchor', function (e) { // click event is only for Product Set
		e.preventDefault();
		$('#product-set').length > 0 && updateSetContent($(this), $(this).attr("href"));
	}).on('selectmenuchange change', '.variation-select', function () { // click event is only for Product Set
		if($('#product-set').length > 0 ) {
			var listItem =  $(this).closest(".product-variations").find('.swatches li[data-selectedcolor="'+ $(this).val() +'"]');
			var link = listItem.find('a.swatchanchor')[0];
			var href = $(link).attr('href');
			updateSetContent($(this), href);
		}	
	}).on('click keydown', '.remaining-count, .custom-dd-disabled .custom-dd-list-item-selected', function (e) { 
		// Allow only click or Enter
		if (e.type === 'keydown' && e.key !== 'Enter') return;
		shadePanelTrigger = document.activeElement;
		shadePanelTriggerSelector = $(this).hasClass('remaining-count')
			? '#product-content .remaining-count'
			: '#product-content #' + $(this).closest('.custom-dd').attr('id') + ' .custom-dd-list-item-selected';

		const isTablet = window.matchMedia('(max-width: 768px)').matches;
		const windowWidth = $(window).width();

		const $shadePanel = $('.product-shade-panel');
		const $panelWrapper = $shadePanel.find('.panel-wrapper');
		const $listItems = $shadePanel.find('.custom-dd-list-item');

		const selectedColor = $('#product-content')
			.find('.color-filter-attr.selected')
			.first()
			.data('color');

		// Set width based on device
		$panelWrapper.css('width', isTablet ? windowWidth : '');

		// Trigger color click (only if exists)
		if (selectedColor) {
			$shadePanel
				.find(`.color-filter-attr[data-color="${selectedColor}"]`)
				.trigger('click');
		}

		// Hide sticky component if needed
		if ($('.pt_product-details').hasClass('sticky-header')) {
			$('.sticky-component').addClass('hidden');
		}

		// Open panel
		$shadePanel.removeAttr('style inert').attr('aria-hidden', 'false').addClass('opened');
		$('html').addClass('modal-open');

		// Move focus into the panel (close icon) before announcing the opened status,
		// so screen readers announce the close button context rather than being interrupted
		accessibility.setKeepFocusInside(document.querySelector('#product-shade-panel'), true);
		isShadePanelFocusTrapActive = true;
		// last item in the panel gets the focus-trap marker; OOS shades stay in tab order
		$listItems.last().addClass('productshadelastelement');
		requestAnimationFrame(function () {
			const closeButton = $shadePanel.find('.icon-close')[0];
			if (closeButton) {
				closeButton.focus();
			}
			$('#product-shade-panel-status').text($shadePanel.data('opened-message'));
		});

	}).on('click keydown', '.product-shade-panel .icon-close, .product-shade-panel .panel-overlay', function (e) { 

		if (e.type === 'keydown' && e.key !== 'Enter') return;
		closeShadePanel();

	}).on('keydown', '.product-shade-panel', function (e) { 
        // ESC to close
        if (e.key === 'Escape') {
			e.preventDefault();
			closeShadePanel();
        }
	});

	$(document).on('keydown', function(e){
		if (!$('.product-shade-panel').hasClass('opened')) {
			return;
		}

		let active = document.activeElement;

			if (e.key === 'Tab') {
				if (!e.shiftKey && $(active).is('.productshadelastelement')) {
					e.preventDefault();
					$('.product-shade-panel .icon-close').focus();
				}

				if (e.shiftKey && $(active).is('.product-shade-panel .icon-close')) {
					e.preventDefault();
					$('.productshadelastelement').focus();
				}
			}

    });

	// change variation based on custom dropdown selection
	$pdpMain.on('click keydown', '#product-content .custom-dd .custom-dd-list-item', function (e) {
		// Trigger only on click OR Enter key
		if (e.type === 'keydown' && e.key !== 'Enter') {
			return;
		}

		let listItem, swatch, link, urlLink, pid;

		if ($(this).closest(".content-pdp").length > 0) { // PDP Specific
			listItem = $('#pdp-swatches li[data-selectedcolor="' + $(this).data("value") + '"]');
			swatch = listItem.find('div.swatchanchor')[0];

			urlLink = Urls.productVariationDetails +
				"?pid=" + $(swatch).attr("data-mpid") +
				"&" + $(swatch).attr("data-varianttype") + "=" + $(swatch).attr("data-variantval") +
				"&Quantity=1&format=ajax";

			urlLink = $("#product-content").parents("#quickview-modal").length > 0
				? urlLink + "&" + $(swatch).attr("data-cartSrcParam")
				: urlLink;

			pid = $(swatch).attr('data-pid');
		} else {
			listItem = $('#pdp-swatches li[data-selectedcolor="' + $(this).data("value") + '"]');
			link = listItem.find('a.swatchanchor')[0];

			urlLink = $(link).attr('href');
			pid = $(link).attr('data-pid');
		}

		// don't change if selected variant clicked
		if ($(this).hasClass('selected') || $(this).data("value") === '') {
			return;
		}

		if(urlLink){
			window.scrollTo(0, 0);
			closeShadePanel(false);
			localStorage.setItem("selColorCat", $(".product-shade-panel").find(".color-filter-attr.selected").attr('data-color'));
			updateContent(urlLink, pid, restoreShadePanelFocus);
			if (pageInfo.pageCategory == "Product Page") {
				window.dataLayer.push(util.filterObj({
					"event": "productInteraction",
					"productName": getProductNameWithoutSpace(),
					"productId": pid,
					"interactionType" : "select_shade_selector"
				}));
			}
		}
	});
	
	updateQuantityOnChange();
	updateReplanishCycle();
	initColorCatFiltersEvents();
	initColorShadesSlider();
	initMiniCrossSellPDP();
	initReassuranceCarousel();
	productSetColorSwatchesCarousel();
	initResizeHandler();
	applyTransparentGradient();
	applyTransparentGradientOnScroll();
	scrollToActiveSizeVariant();
	initEinsteinRecommendations();
	resizeStickySidebar();
	render3DVisualisation();
	hideOverflowingList();
	$(window).on('resize', function() {
		resizeStickySidebar();
		hideOverflowingList();
	});
	
	if ($('.swatchanchor').find('.hexcode-unavailable').length > 0 ) {
		var unselectables = document.querySelectorAll('.unselectable');
		unselectables.forEach((unselectable) => {
			unselectable.classList.add('dynamic-width');
		});
		var swatchanchors = document.querySelectorAll('.swatchanchor');
		swatchanchors.forEach((swatchanchor) => {
			swatchanchor.classList.add('dynamic-width');
		});
	}
	if ($('.color-swatch').find('.hexcode-unavailable').length > 0)  {
		var colorswatches = document.querySelectorAll('.color-swatch');
		colorswatches.forEach((colorswatch) => {
			colorswatch.classList.add('dynamic-width');
		});
	}
	if ($('.custom-dd-list-item-selected').find('.hexcode-unavailable').length > 0){
		var colorswatches = document.querySelectorAll('.color-swatch');
			colorswatches.forEach((colorswatch) => {
				colorswatch.classList.add('dynamic-width');
			});
	}
	if ($('.selectable').find('.hexcode-unavailable').length > 0) {
		var selectables = document.querySelectorAll('.selectable');
		selectables.forEach((selectable) => {
			selectable.classList.add('dynamic-width');
		});
	}
	$('.pdp-page #header-bottom-notification-message').length && $('.sticky-sidebar-container').addClass('header-bottom-active');
	customDropdown.init();

	initRedesignPDPShadeSizeSelector();
};

function getProductNameWithoutSpace() {
	return $("h1.product-name").html().trim();;
}